// extracted by mini-css-extract-plugin
module.exports = {"generalContainer":"logoList_generalContainer__hq6MA","logoListTitle":"logoList_logoListTitle__d66x_"};